module.exports = __webpack_public_path__ + "img/79.9e49a4a.png";